/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cancel_KeepInputs */

const en_cancel_keep = /** @type {(inputs: Cancel_KeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep my plan`)
};

const de_cancel_keep = /** @type {(inputs: Cancel_KeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abo behalten`)
};

const fr_cancel_keep = /** @type {(inputs: Cancel_KeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Garder mon abonnement`)
};

const es_cancel_keep = /** @type {(inputs: Cancel_KeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantener mi plan`)
};

const it_cancel_keep = /** @type {(inputs: Cancel_KeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantieni il mio piano`)
};

const nl_cancel_keep = /** @type {(inputs: Cancel_KeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan behouden`)
};

const pl_cancel_keep = /** @type {(inputs: Cancel_KeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zachowaj plan`)
};

const fi_cancel_keep = /** @type {(inputs: Cancel_KeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sailyta tilaukseni`)
};

const da_cancel_keep = /** @type {(inputs: Cancel_KeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Behold min plan`)
};

const sv_cancel_keep = /** @type {(inputs: Cancel_KeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Behåll min plan`)
};

/**
* | output |
* | --- |
* | "Keep my plan" |
*
* @param {Cancel_KeepInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cancel_keep = /** @type {((inputs?: Cancel_KeepInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cancel_KeepInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cancel_keep(inputs)
	if (locale === "fr") return fr_cancel_keep(inputs)
	if (locale === "es") return es_cancel_keep(inputs)
	if (locale === "it") return it_cancel_keep(inputs)
	if (locale === "nl") return nl_cancel_keep(inputs)
	if (locale === "pl") return pl_cancel_keep(inputs)
	if (locale === "fi") return fi_cancel_keep(inputs)
	if (locale === "da") return da_cancel_keep(inputs)
	if (locale === "sv") return sv_cancel_keep(inputs)
	return en_cancel_keep(inputs)
});